<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.disputeDetails && _vm.disputeDetails.disputeStatus
    ? _c("div", { staticClass: "border rounded pr-2 pl-2 pb-2 mt-2" }, [
        _c("div", { staticClass: "payment-show mt-1" }, [
          _c("div", { staticClass: "payment-method d-inline-block mr-2" }, [
            _vm._v(" " + _vm._s(_vm.$t("orderCreated.Dispute")) + ": "),
          ]),
          _c("div", { staticClass: "payment-name" }, [
            _c("div", { staticClass: "d-inline" }, [
              _vm._v(" " + _vm._s(_vm.disputeDetails.disputeStatus) + " "),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "mt-1" },
          [
            _c(
              "b-button",
              {
                attrs: {
                  to: {
                    name: "disputeStatus",
                    params: {
                      lang: _vm.lang || undefined,
                      id: _vm.$route.params.id,
                    },
                  },
                  variant: "primary",
                },
              },
              [_vm._v(_vm._s(_vm.$t("orderCreated.ViewStatus")))]
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/amount-section/DisputeStatusView.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import * as vuex from 'vuex';
import assets_rashi_coin_copy_svg from '@/assets/rashi-coin/copy.svg';
import utils_clipboard from '@/utils/clipboard';
import layouts_components_ImagePreview_vue from '@/layouts/components/ImagePreview.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






export default ({
  render,
  staticRenderFns,
  components: {
    BImg: bootstrapvue["BImg"],
    Copy: assets_rashi_coin_copy_svg,
    ImagePreview: layouts_components_ImagePreview_vue,
    BButton: bootstrapvue["BButton"]
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  props: {
    disputeDetails: {
      type: Object,
      isRequired: false,
      default: () => {}
    }
  },
  data() {
    return {
      paymentFields: [],
      showImagePop: false,
      popImage: "",
      showDocumentPreviewModal: false,
      url: "",
      type: "",
      lang: this.$route.params.lang
    };
  },
  computed: {
    ...vuex.mapState("user", ["refData"])
  },
  watch: {
    refData(newVal) {
      this.findPaymentMethod();
    },
    disputeDetails(newVal) {
      this.findPaymentMethod();
    }
  },
  mounted() {
    this.findPaymentMethod();
  },
  methods: {
    showImage(flag, url, type) {
      this.showDocumentPreviewModal = flag;
      if (flag) {
        this.url = url;
        this.type = type;
      } else {
        this.url = "";
        this.type = "";
      }
    },
    async copy(text) {
      await utils_clipboard.apply(this, [`${text}`]);
    },
    openQr(url) {
      this.popImage = url;
    },
    findPaymentMethod() {
      if (this.disputeDetails && this.disputeDetails.sellerPaymentMethodInfo && this.disputeDetails.sellerPaymentMethodInfo.paymentMethod && this.refData && this.refData.countryData && this.refData.countryData.paymentMethods && this.refData.countryData.paymentMethods.length) {
        const foundObject = this.refData.countryData.paymentMethods.find(obj => obj.id === this.disputeDetails.sellerPaymentMethodInfo.paymentMethod);
        this.mapFields(foundObject.fields);
      }
    },
    mapFields(fields) {
      this.qrIsRequired = false;
      this.paymentFields = fields.map(field => {
        let value = this.disputeDetails.sellerPaymentMethodInfo[field.id] || null;
        if (field.id === "qrcode.doc") {
          this.qrIsRequired = field.isRequired;
          value = this.disputeDetails.sellerPaymentMethodInfo.accountQrcodeUrl;
        }
        return {
          ...field,
          value
        };
      }) || [];
    }
  }
});

//# sourceURL=webpack:///./src/@core/components/amount-section/DisputeStatusView.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.profile-text {
  color: #686e7d;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
.profile-amt {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: var(--1e2329);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
.profile-amt-green {
  display: flex;
  justify-content: flex-end;
  color: #8dc540;
  font-size: 21px;
  font-weight: 700;
  line-height: 32px;
}
.payment-show {
  display: flex;
  align-items: center;
}
.vertical-red-line {
  display: inline-block;
  width: 2px;
  height: 12px;
  /* border: 2px solid #f7984a; */
  /* background: #f7984a; */
}
[dir] .vertical-red-line {
  margin: 0px 5px 0px 5px;
  border-radius: 4px;
}
.payment-method {
  color: var(--text-black-color);
  font-size: 19px;
  font-weight: 600;
  line-height: 24px;
}
[dir=ltr] .copy_icon {
  margin-left: 6px;
}
[dir=rtl] .copy_icon {
  margin-right: 6px;
}
.copy_icon path {
  fill: #636363;
}
</style>
